import { render, staticRenderFns } from "./search-to-add.vue?vue&type=template&id=0963f0a7&scoped=true&"
import script from "./search-to-add.vue?vue&type=script&lang=js&"
export * from "./search-to-add.vue?vue&type=script&lang=js&"
import style0 from "./search-to-add.vue?vue&type=style&index=0&id=0963f0a7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0963f0a7",
  null
  
)

export default component.exports